export default function R_Numbers() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Numbers Component</h1>
      <p>This is the R_Numbers tutorial section.</p>
    </div>
  );
}
